



















import { Vue, Component } from 'vue-property-decorator';
import { getZhongTongPrintResult } from '@/api/shipment';

@Component({})
export default class ZhongPrintPrint extends Vue {
  pictureKey = [];
  billCodes = [];
  isLoading = true;
  mounted() {
    let key: any = this.$route.query.key;
    let isView: boolean = this.$route.query.isView == 'true';
    this.billCodes = key.split(',');
    if (!isView) {
      this.checkZhongTongPrintResult();
    } else {
      this.isLoading = false;
      this.pictureKey = key.split(',');
    }
  }

  profileUrl(key: string) {
    if (key) {
      return `${process.env.VUE_APP_FILE_URL}/zt_print/${key}`;
    } else {
      return '';
    }
  }

  /**点击了弹窗里面的打印 */
  onConfimPrintClick() {
    // console.log((this.$refs.printDiv as Element).innerHTML);
    let content: string = this.generateHtml();
    let iframe = document.createElement('iframe');
    iframe.id = 'printIframe';
    let f = document.body.appendChild(iframe);
    let w = (f.contentWindow || f.contentDocument) as Window;
    let doc = f.contentDocument || f.contentWindow!.document;
    doc.open();
    doc.write(content);
    doc.close();
    iframe.onload = function() {
      w.focus();
      try {
        if (!w.document.execCommand('print', false)) {
          w.print();
        }
      } catch (e) {
        w.print();
      }
      w.close();
      document.body.removeChild(iframe);
    };
  }

  generateHtml(): string {
    let content: string = (this.$refs.printDiv as Element).innerHTML;
    let html = `<head><style>body{margin:0;padding:0}img{width:100%;height:100%}</style><style>@media print { body { margin: 0; padding: 0; } .page-break { page-break-before: always; }}</style></head><body>${content}</body>`;
    return html;
  }

  /**点击了关闭按钮 */
  onCloseClick() {
    window.close();
  }

  checkZhongTongPrintResult() {
    setTimeout(() => {
      getZhongTongPrintResult({
        billCodes: this.billCodes
      }).then((res: any) => {
        if (res.length == this.billCodes.length) {
          this.pictureKey = res.map((d: any) => d.pictureKey);
          this.isLoading = false;
        } else {
          this.checkZhongTongPrintResult();
        }
      });
    }, 1000);
  }
}
